import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getAPI } from "../../service/http-service";
import { CommonEndpoint } from "../../service/endpointConfig/CommonEndpoint";

let initialState: any = {
  areaResponse: {},
};

// Get Area API call
export const AreaService = createAsyncThunk(
  "master/area",
  async (area: any) => {
    try {
      return await getAPI(CommonEndpoint.area);
    } catch (err) {
      return err;
    }
  }
);

const areaSlice = createSlice({
  name: "area",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      AreaService.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.status = action.payload?.status;
        state.error = "";
        state.data = action.payload?.data?.data;
      }
    );
    builder.addCase(AreaService.rejected, (state, action) => {
      state.loading = false;
      state.status = -1;
      state.error = action.error.message || "Something went wrong";
      state.data = {};
    });
  },
});

const areaReducer = areaSlice.reducer;
export default areaReducer;
